// extracted by mini-css-extract-plugin
export default {"banner":"PromoCodeBanner_banner__PqZms","icon":"PromoCodeBanner_icon__OTRXc","text":"PromoCodeBanner_text__SJs6p","button":"PromoCodeBanner_button__a8oMA"};